import { environment } from './../../../../environments/environment';
import { VillaCollectionContainer } from './../villa-collection.container';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { EventEmitter, ElementRef, Output, Renderer2 } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { IRequest } from '../../../core/models/request';
import { IRoomPeople } from '../../../core/models/roompeople';
import { Angulartics2 } from 'angulartics2';
import { SharedContainer } from '../../../shared/shared.container';
import { ChangeLoadingStatusAction } from './../../../core/store/general/actions';
import { getUserInfo } from './../../../core/store/general/selectors';
import { VillaCollectionService } from '../../../core/services/villa-collection.service';
import { PlatformLocation } from '@angular/common';
import { SwiperOptions } from 'swiper';
import { gsap } from 'gsap';
import { NgxUsefulSwiperModule, SwiperComponent } from 'ngx-useful-swiper';


@Component({
  selector: 'app-villa-single',
  templateUrl: './villa-single.component.html',
  styleUrls: ['./villa-single.component.css', './villa-single.component.scss'],
  styles: [`
    .custom-day {
      text-align: center;
      padding: 0.285rem 0.35rem;
      display: inline-block;
      height: 2rem;
      width: 2rem;
      outline: 0;
    }
    .custom-day:hover {
      background-color: #48a5db;
    }
    .custom-day.focused {
      background-color: #48a5db;
    }
    .custom-day.disabled {
      color: #BCC4F3;
    }
    .custom-day.range, .custom-day:hover {
    }

    .custom-day {
      text-align: center;
      padding: 0.185rem 0.25rem;
      display: inline-block;
      height: 2rem;
      width: 2rem;
    }
    .custom-day.focused {
      background-color: #e6e6e6;
    }
    .custom-day.range, .custom-day:hover {
      background-color: rgb(2, 117, 216);
      color: white;
    }
    .custom-day.faded {
      background-color: rgba(2, 117, 216, 0.5);
    }
  `]
})
export class VillaSingleComponent implements OnInit, NgxUsefulSwiperModule {
  private _url = '${environment.backendRoot}/webresources/frontend/entity.bookingrequest/createRequest/';
  userLogged;
  @Input() facilitiesGroups;
  public roomFacilities;
  public extraFacilities;
  public flatExperiences;
  // @Output() sendRequest: EventEmitter<any> = new EventEmitter();
  @Output() openLoginMOdal: EventEmitter<any> = new EventEmitter();
  @ViewChild('randomClick') randomClick: ElementRef;
  @ViewChild('d2') d2;
  @ViewChild('d1') d1;
  @ViewChild('usefulSwiperVC', { static: false }) usefulSwiperMobile: SwiperComponent;
  @ViewChild('gallery', { static: false }) gallery: ElementRef;
  @ViewChild('carousel', { static: false }) carousel: ElementRef;

  experiencesOpen = false;
  experienceDescriptionVisible: Array<boolean>;
  facilityGroupsFlat = null;
  requestInfo: IRequest;
  yo = true;
  location2: string;
  personalRequest = '';
  //  slider
  max = 2000;
  min = 5;
  step = 5;
  value = 600;
  numberOfNights = 1;

  config: SwiperOptions;


  //  offer
  duration = 5;
  max2 = 60;
  min2 = 1;
  step2 = 1;
  thumbLabel = true;

  whoModalState = '';
  experiencesModalState = '';
  datesModalState = '';

  rooms = [];
  selectedRoomNumber = 1;
  roompersons: Array<IRoomPeople>;

  activeToolTip = 0;
  confirmVisible = false;
  currentStep = 1;
  numberOfSteps = 4;
  hiddenNextBtn = false;
  heights = ['', '0px', '0px', '0px', '0px'];
  steps = [250, 250, 250];
  maxHeight = 280;
  maxStepsHeight = '280px';
  allFacilities;

  minPrice = 5;
  maxPrice = 10000;
  someRange = [this.minPrice, 10000];


  hoveredDate: NgbDate;

  fromDate: NgbDate;
  toDate: NgbDate;

  galleryOpen = false;


  villaId: number;
  images;
  hotel;
  facilities;
  allExperiences;
  experiences;
  rowsForDisplay = 1;
  experiencesCategories: Array<any>;
  environment = environment;
  pageTitle: string;
  showImage = [];

  constructor(private route: ActivatedRoute, private router: Router,
    private villaCollectionContainer: VillaCollectionContainer,
    private titleService: Title,
    private calendar: NgbCalendar,
    private sharedContainer: SharedContainer,
    private villaAPI: VillaCollectionService,
    private location3: PlatformLocation, private meta: Meta,
  ) {
    this.location3.onPopState(() => {
      this.showPropertyButton();
      this.showSecondaryMenu();
      this.titleService.setTitle('Villa Collection' + ' ' + '|' + ' ' + 'Vervendo.com');
    });
    this.experiencesCategories = new Array();
    this.location2 = 'Chania';

    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 1);

    this.config = {
      pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      spaceBetween: 0,
      on: {
        slideChangeTransitionEnd: () => {
          // this.swiperRealIndex = this.usefulSwiperMobile.swiper.activeIndex + 1;
          // this.usefulSwiperMobile.swiper.setTranslate = -375;
        }
      }
    };
  }

  ngOnInit() {
    this.hidePropertyButton();
    this.hideSecondaryMenu();
    this.hideBookInfo();
    this.addMarginToHeader();
    this.userLogged = this.sharedContainer.isLoggedIn$;
    this.roomFacilities = this.villaAPI.getRoomFacilities();
    const urlSegments = this.route.snapshot.url[0].path.split('-');

    const potentialVillaId = parseInt(urlSegments[urlSegments.length - 1], 10);
    console.log(potentialVillaId);
    if (isNaN(potentialVillaId)) {
      this.router.navigate(['/404']);
    }
    this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, { isLoading: true }));
    this.villaCollectionContainer.getSingleVillaInfo(potentialVillaId).subscribe(arg => {
      console.log(arg);
      this.hotel = arg;
      // if (this.hotel.name.length < 46) {
      //   this.meta.addTag({ name: 'Hotel', content: this.hotel.name + ' - By Vervendo' });
      // } else {
      //   this.meta.addTag({ name: 'Hotel', content: this.hotel.name + ' - Vervendo' });
      // }
      this.titleService.setTitle(this.hotel.name + ' ' + '|' + ' ' + 'Vervendo.com');
      if (this.hotel.description) {
        this.hotel.description = this.hotel.description.replace(/\n/g, '<br>');
      }

      this.facilities = {
        general: this.hotel.hotelFacilitiesCollection.filter(
          facility => facility.facility.facilityGroupName === 'General').map(facility => facility.facility.name),
        activities: this.hotel.hotelFacilitiesCollection.filter(
          facility => facility.facility.facilityGroupName === 'Activities').map(facility => facility.facility.name),
        services: this.hotel.hotelFacilitiesCollection.filter(
          facility => facility.facility.facilityGroupName === 'Services').map(facility => facility.facility.name),
      };
    });

    this.villaCollectionContainer.getVillaPictures(potentialVillaId).subscribe(photos => {
      console.log(photos);
      this.images = photos;
    });

    this.villaCollectionContainer.getVillaExperiences(potentialVillaId).subscribe(experiences => {
      console.log(experiences);
      this.allExperiences = experiences;
      this.experiences = this.allExperiences.slice(0, 5);
      this.fillExperiencesCategories();
      this.experienceDescriptionVisible = new Array(this.allExperiences.length).fill(false);
      this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, { isLoading: false }));
    });
    this.initRooms();
    this.roompersons = new Array();
    this.initRoomPerson();
  }


  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  test(event, index) {
    console.log(event);
    this.showImage[index] = true;
  }

  getArray(size) {
    return new Array(size).fill(0);
  }

  goBack() {
    this.router.navigate(['villa-collection/']);
    this.titleService.setTitle('Villa Collection' + ' ' + '|' + ' ' + 'Vervendo.com');
    this.showPropertyButton();
    this.showSecondaryMenu();
  }

  isMobile = () => (window.innerWidth < 992) ? true : false;

  openGallery() {
    if (!this.isMobile()) {
      if (!this.galleryOpen) {
        this.animationGallery();
        this.galleryOpen = true;
      }
    }
  }

  animationGallery() {
    const modal = gsap.timeline();

    modal.fromTo('.popupVC', { y: 550, opacity: 0 },
      { y: 0, opacity: 5, duration: 1, ease: 'elastic.out(0.7, 1)' });
  }


  loadMoreExperiences() {
    this.rowsForDisplay++;
    this.displayExperiences();
  }

  loadLessExperiences() {
    this.rowsForDisplay = 1;
    this.displayExperiences();
  }

  displayExperiences() {
    if (this.rowsForDisplay * 5 < this.allExperiences.length) {
      this.experiences = this.allExperiences.slice(0, 5 * this.rowsForDisplay);
    } else {
      this.experiences = this.allExperiences.slice(0, this.allExperiences.length);
    }
  }

  isMoreExperiencesAvailable() {
    if (this.allExperiences) {
      return 5 * this.rowsForDisplay < this.allExperiences.length;
    }
    return false;
  }

  fillExperiencesCategories() {
    for (let i = 0; i < this.allExperiences.length; i++) {
      if (this.allExperiences[i].optionalExtraCategory) {
        if (this.experiencesCategories.find(e => (e === this.allExperiences[i].optionalExtraCategory.category))) {
          continue;
        }
        this.experiencesCategories.push(this.allExperiences[i].optionalExtraCategory.category);
      }
    }
  }

  onSlide({ prev, current, direction }) {
    //        console.log('slideChange: ' + current);
    if (this.images[current]) {
      this.images[current].preloaded = true;
    }
    if (this.images[current + 1]) {
      this.images[current + 1].preloaded = true;
    }
  }


  hideDatesModal() {
    this.datesModalState = '';
    // this.roompersons = [];
  }

  onDateSelection(date: NgbDate) {
    const selectedDate = { day: date.day, month: date.month, year: date.year };
    const fromDate = { day: this.fromDate.day, month: this.fromDate.month, year: this.fromDate.year };
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && this.isAfter(selectedDate, fromDate)) {
      this.toDate = date;
      this.hideDatesModal();
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    const selectedDate = { day: date.day, month: date.month, year: date.year };
    const fromDate = { day: this.fromDate.day, month: this.fromDate.month, year: this.fromDate.year };
    if (!this.hoveredDate) {
      return false;
    }
    const hdate = { day: this.hoveredDate.day, month: this.hoveredDate.month, year: this.hoveredDate.year };
    return this.fromDate && !this.toDate && this.hoveredDate &&
      this.isAfter(selectedDate, fromDate) && this.isBefore(selectedDate, hdate);
  }

  isInside(date) {
    const selectedDate = { day: date.day, month: date.month, year: date.year };
    const fromDate = { day: this.fromDate.day, month: this.fromDate.month, year: this.fromDate.year };

    let toDate;
    if (this.toDate) {
      toDate = { day: this.toDate.day, month: this.toDate.month, year: this.toDate.year };
    }
    this.isInside1(selectedDate, fromDate, toDate);
  }

  isInside1(selectedDate, startDate, endDate) {
    if (endDate && startDate) {
      return this.isAfter(selectedDate, startDate) && this.isBefore(selectedDate, endDate);
    }
    return false;
  }

  isRange(date: NgbDate) {
    const selectedDate = { day: date.day, month: date.month, year: date.year };
    const fromDate = { day: this.fromDate.day, month: this.fromDate.month, year: this.fromDate.year };

    let toDate;
    if (this.toDate) {
      toDate = { day: this.toDate.day, month: this.toDate.month, year: this.toDate.year };
    }

    return this.isDatesEqual(selectedDate, fromDate) || this.isDatesEqual(selectedDate, toDate)
      || this.isInside1(selectedDate, fromDate, toDate) || this.isHovered(date);
  }

  isDateDisabled(date) {
    const xx = { day: date.day, month: date.month, year: date.year };
    const selectedDate: NgbDate = NgbDate.from(xx);
    const dateObj = new Date();
    const ngbDateStruct = { day: dateObj.getDate(), month: dateObj.getMonth() + 1, year: dateObj.getFullYear() };
    const currentDate = NgbDate.from(ngbDateStruct);
    let isDisabled = true;
    if (xx.year < ngbDateStruct.year) {
      isDisabled = false;
    }
    if (xx.year === ngbDateStruct.year) {
      if (xx.month < ngbDateStruct.month) {
        isDisabled = false;
      }
      if (xx.month === ngbDateStruct.month) {
        if (xx.day < ngbDateStruct.day) {
          isDisabled = false;
        }
      }
    }

    return !isDisabled;
  }

  isEndDateDisabled(date) {
    const xx = { day: date.day, month: date.month, year: date.year };
    if (this === null || this === undefined) {
      return;
    }
    if (this.fromDate === null || this.fromDate === undefined) {

    }

    let isDisabled = true;
    if (xx.year < this.fromDate.year) {
      isDisabled = false;
    }
    if (xx.year === this.fromDate.year) {
      if (xx.month < this.fromDate.month) {
        isDisabled = false;
      }
      if (xx.month === this.fromDate.month) {
        if (xx.day <= this.fromDate.day) {
          isDisabled = false;
        }
      }
    }

    return !isDisabled;
  }

  showWhoModal() {
    this.whoModalState = 'show';
    this.experiencesModalState = '';
    this.datesModalState = '';
  }

  hideModal() {
    this.whoModalState = '';
    // this.roompersons = [];
  }

  showExperiencesModal() {
    this.experiencesModalState = 'show';
    this.whoModalState = '';
    this.datesModalState = '';
  }

  hideExperiencesModal() {
    this.experiencesModalState = '';
    // this.roompersons = [];
  }

  showDatesModal() {
    this.datesModalState = 'show';
    this.experiencesModalState = '';
    this.whoModalState = '';
  }

  setRoomNumber(roomNumber) {
    this.selectedRoomNumber = parseInt(roomNumber.split('m').pop(), 10);
    const childrenSize = this.selectedRoomNumber - this.roompersons.length;
    if (this.selectedRoomNumber > this.roompersons.length) {
      for (let i = 0; i < childrenSize; i++) {
        const roomPeople = {
          adults: 1,
          children: []
        };
        this.roompersons.push(roomPeople);
      }
    } else if (this.selectedRoomNumber < this.roompersons.length) {
      for (let i = this.roompersons.length - 1; i >= this.selectedRoomNumber; i--) {
        this.roompersons.pop();
      }
    }
  }

  saveRoomPeople(roomPeopleInfo) {
    this.roompersons[roomPeopleInfo[0] - 1] = roomPeopleInfo[1];
  }

  submitModal() {
    this.whoModalState = '';
    this.experiencesModalState = '';
    this.datesModalState = '';
  }

  createRequest() {
    this.fillRequest();
    this.sendRequest(this.requestInfo);
  }

  fillRequest() {
    // const fromDate = new Date(this.checkin.year, this.checkin.month - 1, this.checkin.day + 1);
    // const toDate = new Date(this.checkout.year, this.checkout.month - 1, this.checkout.day + 1);

    const fromDate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day + 1);
    const toDate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day + 1);

    this.requestInfo = {
      location: this.location2,
      latitude: 35.5138298,
      longitude: 24.0180367,
      fromdate: fromDate.toISOString().substring(0, 10).replace(/-0/g, '-'),
      todate: toDate.toISOString().substring(0, 10).replace(/-0/g, '-'),
      maxprice: this.someRange[1],
      minprice: this.someRange[0],
      rooms: this.roompersons.length,
      roompersons: this.fillRoomPersonsRequest(), // this.roompersons,

      roomLift: false,
      disableAccess: false,
      smoking: false,

      roomLiftOpt: false,
      disableAccessOpt: false,
      smokingOpt: 'Both',

      starRating: -1,
      accomType: -1,
      mealType: -1,

      personalReq: this.personalRequest,
      requestExpiry: Date.now() + (this.duration * 1000 * 60 * 60 * 24),
      hotelfacilities: '', // this.filterFacilities(this.facilitiesGroups),
      hotelroomfacilities: '', // this.filterFacilities(this.roomFacilities),
      opthotelfacilities: '', // this.filterFacilities(this.facilitiesGroups),
      opthotelroomfacilities: '', // this.filterFacilities(this.roomFacilities),
      hotelextras: [], // this.filterExtraFacilities(this.extraFacilities),
      userid: -1
    };
  }

  sendRequestGuest() {
    this.fillRequest();
    this.sendRequest(this.requestInfo);
  }

  initRooms() {
    this.rooms = this.fillRange(10, 1);
  }


  initRoomPerson() {
    const roomPeople = {
      adults: 1,
      children: []
    };
    this.roompersons.push(roomPeople);
  }

  fillRange(size, start) {
    return Array.from(Array(size), (x, i) => (i + start));
  }

  fillRoomPersonsRequest() {
    const roomPeopleReaquest = this.roompersons.map(roomPerson => {
      return { 'adults': String(roomPerson.adults), 'children': roomPerson.children };
    });
    return roomPeopleReaquest;
  }

  filterExtraFacilities(facilityGroup) {
    let facilities = [];
    for (const [key, value] of Object.entries(facilityGroup)) {
      const facilitiesPart = value['facilities'].filter(facility => {
        return facility.isChecked === true;
      });
      facilities = facilities.concat(facilitiesPart);
    }

    const options = facilities.map((facility) => ({ id: facility.id, subcategories: '' }));

    if (options.length < 1) {
      return [];
    }
    return options;
  }

  isDatesEqual(date1, date2) {
    if (date1 && date2) {
      return (date1.year === date2.year && date1.month === date2.month && date1.day === date2.day) ? true : false;
    }
    return false;
  }

  isAfter(date1, date2) {
    let isafter = true;

    if (date1.year < date2.year) {
      isafter = false;
    }
    if (date1.year === date2.year) {
      if (date1.month < date2.month) {
        isafter = false;
      }
      if (date1.month === date2.month) {
        if (date1.day < date2.day) {
          isafter = false;
        }
      }
    }
    return isafter;
  }

  isBefore(date1, date2) {
    let isbefore = true;

    if (date1.year > date2.year) {
      isbefore = false;
    }
    if (date1.year === date2.year) {
      if (date1.month > date2.month) {
        isbefore = false;
      }
      if (date1.month === date2.month) {
        if (date1.day >= date2.day) {
          isbefore = false;
        }
      }
    }
    return isbefore;
  }


  isExperincesOpen() {
    return this.experiencesOpen;
  }

  toggleExperiences() {
    console.log(this.experiencesOpen);
    this.experiencesOpen = !this.experiencesOpen;
  }

  showConfirm() {
    this.fillRequest();
    if (this.userLogged) {
      this.sendRequest(this.requestInfo);
    } else {
      this.confirmVisible = true;
    }
  }

  sendRequest(request) {
    this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, { isLoading: true }));
    if (this.userLogged) {
      this.sharedContainer.generalState$.select(getUserInfo).subscribe(user => {
        if (user) {
          request.userid = user.id;
        } else {
          // request[0].userid = -1;
        }

        this.villaCollectionContainer.sendRequest(request).subscribe((reply) => {
          this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, { isLoading: false }));
          this.router.navigate(['results/' + reply['id']]);
        });
      });
    } else {
      this.villaCollectionContainer.sendRequest(request).subscribe((reply) => {
        this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, { isLoading: false }));
        this.router.navigate(['results/' + reply['id']]);
      });
    }

  }

  hidePropertyButton() {

    const x = document.getElementById('property');
    if (x) {
      x.style.visibility = 'hidden';
    }
  }

  hideSecondaryMenu() {

    const y = document.getElementById('menuSecond');
    if (y) {
      y.style.visibility = 'hidden';
    }
  }

  showPropertyButton() {

    const x = document.getElementById('property');
    if (x) {
      x.style.visibility = 'visible';
    }
  }

  showSecondaryMenu() {

    const y = document.getElementById('menuSecond');
    if (y) {
      y.style.visibility = 'visible';
    }
  }

  addMarginToHeader() {
    const y = document.getElementById('headerSorting');
    if (y) {
      y.style.marginTop = '-50px';
    }
  }

  showBookInfo() {
    const v = document.getElementById('bookInfo');
    if (v) {
      v.style.visibility = 'visible';
    }
  }

  hideBookInfo() {
    const w = document.getElementById('bookInfo');
    if (w) {
      w.style.visibility = 'hidden';
    }

  }

  changeTitle() {
    this.titleService.setTitle('Book Your Villa in Crete' + ' ' + '|' + ' ' + 'Book With Vervendo.com');
  }

  getWhoText() {
    let adults = 0;
    let children = 0;
    if (this.roompersons.length > 0) {
      for (const roomPerson of this.roompersons) {
        adults += roomPerson.adults;
        children += roomPerson.children.length;
      }
      // return this.roompersons.length + ' room ' + adults + ' adults ' + children + ' children';
      return { adults, children };
    }
    adults = 2;
    children = 0;
    return { adults, children };
  }

  isExperienceDescriptionVisible(experienceindex) {

    return this.experienceDescriptionVisible[experienceindex];
  }

  readMore(experienceindex) {
    this.experienceDescriptionVisible[experienceindex] = !this.experienceDescriptionVisible[experienceindex];
  }
}
